export default "__VITE_ASSET__DVfZzZOr__"